<template>
  <div class="categoryList">
    <div class="item" :class="isActive === item.ID ? 'is-active':''"
         v-for="item of navData"
         :key="item.ID"
         @click="handleNav(item)"
         :title="item.NAME"
    >{{item.NAME}}</div>
  </div>
</template>

<script>
    export default {
      name: "LeftMenu",
      props:{
        active:{
          default: '',
          type:String,
        },
        data:{
          default:[],
          type:Array,
        },
      },
      data(){
        return{
          isActive:this.active,
          navData:this.data,
        }
      },
      methods:{
        handleNav(item){
          this.isActive = item.ID;
          this.$emit('columnClick',item);
        },
      },
    }
</script>

<style lang="css" scoped>
  .categoryList{
    padding:10px 0;
  }
  .categoryList .item{
    height: 40px;
    line-height: 40px;
    color:#B8B8B8;
    padding:0 20px;
    text-align: center;
    cursor: pointer;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
  .categoryList .item.is-active{
    position: relative;
    font-weight: bold;
    color:#3C9B9E;
  }
  .categoryList .item.is-active:before,
  .categoryList .item.is-active:after{
    position: absolute;
    top:9px;
    display: inline-block;
    content: '';
    background-size: 100% 100%;
    background-position: left top;
    background-repeat: no-repeat;
    width: 12px;
    height: 19px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/categry/components/LeftMenu.vue